import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    session_record_id: 0,
    rcapt_token: null,
    employee_number: 0,
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
